module.exports = __webpack_public_path__ + "img/7aiodDn7fqWuTcAwBrIuuVqOG2RYvRunWnLyNnu1.3ca9d142.jpg";